import { createContext, useContext, useState, useEffect } from 'react';
import { useSession } from '@clerk/clerk-react';
import { Resource } from 'shared/types/resource';
import { fetchResourcesFromAPILegacy } from 'shared/api/fetch-resources';

type ResourcesContextType = {
    resources: Resource[];
    refreshResources: () => Promise<void>;
};

const ResourcesContext = createContext<ResourcesContextType | undefined>(undefined);

export const useResources = () => {
    const context = useContext(ResourcesContext);
    if (!context) {
        throw new Error('useResources must be used within a ResourcesProvider');
    }
    return context;
};

export const ResourcesProvider = ({ children }: any) => {
    const [resources, setResources] = useState<Resource[]>([]);
    const session = useSession();

    const refreshResources = async () => {
        // fetch the tasks and update state
        if (session.isLoaded && session.isSignedIn) { // Only fetch if session is loaded and user is signed in
            const newResources = await fetchResourcesFromAPILegacy(session.session);
            setResources([...newResources]);
        }
    };

    useEffect(() => {
        refreshResources();
    }, [session.isLoaded, session.isSignedIn]); // Dependency array watches for changes in session load state and sign-in state

    return (
        <ResourcesContext.Provider value={{ resources, refreshResources }}>
            {children}
        </ResourcesContext.Provider>
    );
};
